import {h, Component} from "preact";

export default class VisibleOnHash extends Component {
	state = {
		opened: false
	}
	componentWillMount() {
		window.addEventListener('hashchange', this.openHandler = e => {
			this.setState({opened: window.location.hash == this.props.hash});
		});
		this.setState({opened: window.location.hash == this.props.hash});
	}
	componentDidUnmount() {
		window.removeEventListener('hashchange', this.openHandler);
	}
	render({children, ...props}) {
		return <div {...props} class={props['class']+(this.state.opened ? '' : ' hidden')}>
			{children}
		</div>
	}
}